'use client';

import QueryMatchLanding from '@/components/QueryMatchLanding';

export default function LandscapingAnsweringServicePage() {
  return (
    <QueryMatchLanding
      pageName="Landscaping Answering Service"
      analyticsContext="landscaping_answering_service"
      eyebrow="Landscaping answering service"
      h1="Landscaping Answering Service That Captures Quotes Mid-Job"
      subhead="When your hands are in the dirt, Greet answers quote requests and books consultations-an AI receptionist for landscaping that costs less than traditional answering services."
      bullets={[
        'Captures spring-rush quote calls you would otherwise miss',
        'Books consultations while you stay on the job site',
        'Flags storm damage and emergency tree work immediately',
        'Flat-rate pricing vs. $200–$400/mo answering service plans',
      ]}
      industryLabel="Landscapers"
      industryHref="/landscapers"
      industryCtaLabel="See the full landscapers page"
      accent="emerald"
    />
  );
}
